import { styled } from 'styled-components'
import { ReactComponent as CloseSvg } from 'icons/assets/X.svg'

// X.svg's cross spans 11.31 of its 32 units; at this size it matches the design's 10.6px cross.
const DISMISS_ICON_SIZE_PX = 30
// Centres the icon on the design's 20px X, inset 14px from the card's top-right corner.
const DISMISS_ICON_INSET_PX = 9

export const Card = styled.div`
  position: relative;
  overflow: hidden;
  border: 1px solid ${({ theme }) => theme.colors.grayAccent};
  border-radius: 24px;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0 4px 13px rgba(43, 5, 20, 0.04);
  transition: box-shadow 0.2s;

  @media (hover: hover) {
    &:hover {
      box-shadow: 0 4px 13px rgba(43, 5, 20, 0.12);
    }
  }
`

export const OpenButton = styled.button`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 24px;
  width: 100%;
  /* The design's 128px card, inside its border. */
  min-height: 126px;
  margin: 0;
  padding: 0;
  border: none;
  background: none;
  color: ${({ theme }) => theme.colors.secondaryDark};
  font: inherit;
  text-align: start;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
`

export const Copy = styled.span`
  display: flex;
  /* The design's text column, narrower on small phones. */
  flex: 0 1 182px;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  min-width: 0;
  /* Centres a two-line title in the design's card and keeps longer copy below the X: it grows the card instead. */
  padding-block: 27px;
  font-size: 17px;
`

export const Title = styled.span`
  font-weight: 600;
  line-height: 23px;
  text-wrap: balance;
  /* On a phone the text column runs to the card's edge, so a long title (most translations) would sit under the X. */
  padding-inline-end: ${DISMISS_ICON_INSET_PX + DISMISS_ICON_SIZE_PX}px;
`

export const Cta = styled.span`
  font-weight: 400;
  line-height: 22px;
  text-decoration: underline;
  text-decoration-skip-ink: none;
  text-underline-position: from-font;
  transition: color 0.2s;

  @media (hover: hover) {
    ${OpenButton}:hover & {
      color: ${({ theme }) => theme.colors.black};
    }
  }
`

export const DismissButton = styled.button`
  position: absolute;
  top: ${DISMISS_ICON_INSET_PX}px;
  right: ${DISMISS_ICON_INSET_PX}px;
  display: flex;
  padding: 0;
  border: none;
  background: none;
  color: ${({ theme }) => theme.colors.grayDark};
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
`

export const DismissIcon = styled(CloseSvg)`
  width: ${DISMISS_ICON_SIZE_PX}px;
  height: ${DISMISS_ICON_SIZE_PX}px;
`
